'use es6';

import { createSelector } from 'reselect';
import { getMatchPath } from './matchSelectors';
import { PATHS } from '../constants/base';
import { selectHasPerformanceTabAccess } from './authSelectors';
export const getLocation = (_, props) => props.location;

const getLocationByName = setting => createSelector([getLocation], location => location[setting]);

export const getLocationPathname = getLocationByName('pathname');
export const getMatchDefaultPath = createSelector([selectHasPerformanceTabAccess], hasPerformanceTabAccess => {
  return hasPerformanceTabAccess ? PATHS.PERFORMANCE : PATHS.OPTIMIZATION;
});
export const getLocationSection = createSelector([getLocationPathname, getMatchDefaultPath], (pathname, defaultPath) => {
  if (pathname.includes(PATHS.PERFORMANCE)) {
    return PATHS.PERFORMANCE;
  } else if (pathname.includes(PATHS.OPTIMIZATION)) {
    return PATHS.OPTIMIZATION;
  } else if (pathname.includes(PATHS.SMART_CONTENT)) {
    return PATHS.SMART_CONTENT;
  } else if (pathname.includes(PATHS.TEST_RESULTS)) {
    return PATHS.TEST_RESULTS;
  }

  return defaultPath;
});
export const getLocationRoute = createSelector([getMatchPath, getLocationSection], (path, section) => ({
  path: `${path}:${section}`
}));